<div class="container-fluid p-0">
  <div class="row g-0">
    <div class="col-xl-9">
      <div class="auth-full-bg pt-lg-5 p-4">
        <div class="w-100">
          <div class="bg-overlay" style="background: url(../../assets/Layout/images/illustration1.svg) no-repeat center !important;"></div>

        </div>
      </div>
    </div>

    <!-- end col -->

    <div class="col-xl-3">
      <div class="auth-full-page-content p-md-5 p-4">
        <div class="w-100">
          <div class="d-flex flex-column h-100">
            <div class="mb-2">
              <a class="d-block auth-logo">
                <img src="assets/Layout/images/logo-dark.png" alt="" height="60" class="auth-logo-dark">
              </a>
            </div>
            <div class="my-auto">
              <div id="divLogin">
                <div *ngIf="pubLogo==''">
                  <h5 class="text-primary">Welcome Back!</h5>
                  <p class="text-muted">Sign in to continue to Sesame!</p>
                </div>
                <div class="text-center" *ngIf="pubLogo!=''">
                  <img src="assets/Images/Publishers/{{pubLogo}}.png" alt="" height="60" class="auth-logo-dark">
                </div>
              </div>
              <div id="divReset" style="display:none">
                <h5 class="text-primary">Reset Password</h5>
                <p class="text-muted">Reset Password with Sesame.</p>
              </div>

              <ul class="nav nav-tabs nav-tabs-custom" id="Tabul" *ngIf="modelItem.SSOEnable==true">
                <li class="nav-item"><a data-toggle="tab" href="#SesameTab" class="nav-link active">Sesame User</a></li>
                <li class="nav-item"> <a data-toggle="tab" href="#SSOTab" class="nav-link">SSO User</a></li>
              </ul>
              <div class="tab-content">
                <div id="SesameTab" class="tab-pane active">
                  <div class="mt-4">
                    <div ng-controller="LoginController">
                      <div class="row" *ngIf="modelItem.AuthenticateType=='Direct'">
                        <form *ngIf="isShownLogin==true" id="login-form" autocomplete="off">
                          <div class="splogin"><span>Login</span></div>

                          <div id="divMfVendor" *ngIf="MfVendorList != null">
                            <label for="ddlMfVendor" class="form-label">Vendor</label><em>*</em>
                            <select class="form-control selctrl" id="ddlMfVendor">
                              <option value=0>
                                Select Vendor
                              </option>
                              <option *ngFor="let item of MfVendorList" value={{item.ID}}>
                                {{item.VendorName}}
                              </option>
                            </select>
                          </div>

                          <div *ngIf="LoginMode=='Default'">

                            <div class="mb-3">
                              <label for="username" class="form-label">Username</label><em>*</em>
                              <input type="text" class="form-control" id="username" tabindex="1" placeholder="User Name" name="LoginID" [(ngModel)]="LoginID"
                                     autofocus maxlength="{{modelItem.UserNameMaxlength}}" autocomplete="off" required />
                            </div>

                            <div class="mb-3">
                              <div class="float-end">
                                <a href="javascript:void(0)" class="text-muted" (click)="toggleShow('Reset')">Forgot password?</a>
                                <!--<a href="auth-recoverpw-2.html" class="text-muted">Forgot password?</a>-->
                              </div>
                              <label for="password" class="form-label">Password</label><em>*</em>
                              <div class="input-group auth-pass-inputgroup">
                                <input type="password" class="form-control" id="password" tabindex="2" placeholder="Password" name="Password" [(ngModel)]="Password" maxlength="{{modelItem.PasswordMaxlength}}" pattern="{{modelItem.PasswordFormat}}" autocomplete="off" required />
                                <button class="btn btn-light" type="button" id="password-addon" (click)="updateType()"><i class="far fa-eye-slash"></i></button>
                              </div>
                            </div>

                            <div class="form-check" style="display:none">
                              <input class="form-check-input" type="checkbox" id="remember-check">
                              <label class="form-check-label" for="remember-check">
                                Remember me
                              </label>
                            </div>

                          </div>

                          <div *ngIf="LoginMode=='apsauthorproof'">
                            <div class="mb-3">
                              <label for="password" class="form-label">Article Accession Code</label><em>*</em>
                              <div class="input-group auth-pass-inputgroup">
                                <input type="text" class="form-control" id="Accession Code" tabindex="1" placeholder="ArticleId"
                                       autofocus name="Password" [(ngModel)]="Password"
                                       maxlength="255" autocomplete="off" required />
                              </div>
                            </div>

                            <div class="mb-3">
                              <label for="Author" class="form-label">Corresponding Author</label><em>*</em>
                              <input type="text" class="form-control" id="Author" tabindex="2" placeholder="Email (case senstive)"
                                     name="LoginID" [(ngModel)]="LoginID"
                                     maxlength="255" autocomplete="off" required />
                            </div>
                          </div>

                          <div class="mt-3 d-grid">
                            <button class="btn btn-primary waves-effect waves-light" (click)="Authenticate()" type="submit">Log In</button>
                            <div style="color:red">{{message}}</div>
                          </div>

                        </form>

                        <form *ngIf="isShownReset==true" id="register-form">
                          <div class="splogin"><span>Reset Password</span></div>
                          <button type="button" id="btnResetOption" (click)="ResetSelection()" style="display:none"></button>
                          <div class="mb-3">
                            <label for="username" class="form-label">Username</label><em>*</em>
                            <input type="text" class="form-control" id="username" placeholder="User Name" name="LoginIDReset" [(ngModel)]="LoginIDReset" autofocus maxlength="{{modelItem.UserNameMaxlength}}" autocomplete="off" />
                          </div>
                          <div class="mb-3">
                            <label for="ddlResetOption" class="form-label">Reset Option</label><em>*</em>
                            <select id="ddlResetOption" class="form-control selctrl" onchange="$('#btnResetOption').trigger('click')">
                              <option value="Email" selected>Using Email Notification</option>
                              <option value="SecurityQuestion">Using Security Question</option>
                            </select>
                          </div>
                          <div class="mb-3">
                            <div id="divEmail">
                              <label for="" class="form-label">Email</label><em>*</em>
                              <input type="text" class="form-control" placeholder="Enter Registered Email" name="RegisterEmail" [(ngModel)]="RegisterEmail" maxlength="50" autocomplete="off" />
                            </div>
                          </div>
                          <div class="mb-3">
                            <div id="divSQ" style="display:none">
                              <label for="ddlSQList" class="form-label">Question</label><em>*</em>
                              <select class="form-control selctrl" id="ddlSQList">
                                <option value=0>
                                  Select Security Question
                                </option>
                                <option *ngFor="let item of SQList" value={{item.ID}}>
                                  {{item.Questions}}
                                </option>
                              </select>
                              <label for="" class="form-label">Answer</label><em>*</em>
                              <input type="text" class="form-control" placeholder="Answer" name="SQAnswer" [(ngModel)]="SQAnswer" maxlength="{{modelItem.SQAnswerMaxlength}}" autocomplete="off" />
                            </div>
                          </div>
                          <div class="mt-3 d-grid">
                            <button type="button" class="btn btn-primary waves-effect waves-light" (click)="ResetPassword()">Reset</button>
                          </div>
                          <div class="mt-5 text-center">
                            <p>Remember It ? <a href="javascript:void(0)" class="text-muted" (click)="toggleShow('Login')">Sign In here</a><!--<a href="auth-login-2.html" class="fw-medium text-primary"> </a>--> </p>
                          </div>
                        </form>
                      </div>
                      <div class="row" *ngIf="modelItem.AuthenticateType=='Biometric'">
                        <!--This is for Finger prints,Voices face authentication-->
                        <p>Biometric</p>
                      </div>
                      <div class="row" *ngIf="modelItem.AuthenticateType=='Two-factor'">
                        <!--Need to develop-->
                        <p>Two-Factor</p>
                      </div>
                      <div class="row" *ngIf="modelItem.AuthenticateType=='Multi-factor'">
                        <!--Need to develop-->
                        <p>Multi-Factor</p>
                      </div>
                      <div class="row" *ngIf="modelItem.AuthenticateType=='Captcha'">
                        <!--Need to develop-->
                        <p>Captcha</p>
                      </div>

                    </div>
                  </div>
                </div>
                <div id="SSOTab" class="tab-pane">
                  <div class="mt-4 text-center">
                    <div *ngIf="modelItem.SSOEnable==true">
                      <h5 class="font-size-14 mb-3">Sign in with</h5>
                      <div class="mt-3 d-grid">
                        <button class="btn btn-danger waves-effect waves-light" *ngIf="!loginDisplay" (click)="SSOAuthenticate()" type="submit">Office 365 Login</button>
                      </div>
                    </div>
                    <br /><br /><br /><br /><br /><br />
                  </div>
                </div>
              </div>

            </div>
            <div class="mt-4 text-center">
              <a class="text-center">
                <img src="assets/Images/NTSLogo.png" alt="" height="100" class="auth-logo-dark">
              </a>
              <p class="mb-0">
                © {{currentYear}} Sesame
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end col -->
  </div>
  <!-- end row -->
</div>
